module.exports = __webpack_public_path__ + "img/1af7df0.png";